import { useQuery } from "@tanstack/react-query";
import { useContext, useMemo } from "react";
import { wordpressClient } from "../App";
import { RefetchIntervals } from "../contants/RefetchIntervals";
import { OmroepContext } from "../context/omroepContext";
import { PostSlidePreprocessed } from "../types/transformedType";
import { useProcessWordpressSlides } from "./useProcessWordpressSlides";

export function useWordpressSlides(posts: PostSlidePreprocessed[]) {
  const omroepContext = useContext(OmroepContext);
  const { data: wpSlides } = useQuery({
    queryKey: ["slides", [...omroepContext.slides].sort()],
    queryFn: async () => {
      if(omroepContext.slides.length === 0) return [];
      return wordpressClient.slide().dangerouslyFindAll(new URLSearchParams({ order: "asc", orderby: "menu_order", include: omroepContext.slides.join(",") }));
    },
    initialData: [],
    refetchInterval: RefetchIntervals.slides
  });
  const orderdSlides = useMemo(() => [...wpSlides].sort((a, b) => omroepContext.slides.indexOf(a.id) - omroepContext.slides.indexOf(b.id)), [omroepContext.slides, wpSlides]);

  const { slides } = useProcessWordpressSlides(posts, orderdSlides);

  return { slides };
}
